import { Header } from '@/components/Header';
import { StyledMainLayout, HeaderLine, StyledContent, StyledLayout } from './styles';
import { TopBar } from '@/components/TopBar';

type MainLayoutProps = {
  children: React.ReactNode;
};

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <StyledMainLayout>
      <TopBar />
      <StyledLayout>
        <Header />
        <HeaderLine role='separator' aria-orientation='vertical'/>
        <StyledContent>{children}</StyledContent>
      </StyledLayout> 
    </StyledMainLayout>
    
  );
}